import {
  configureStore,
  Middleware,
  MiddlewareAPI,
  isRejectedWithValue,
} from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { reducers, actions } from '~/client/reducers';
import { apiReducers, apiSlices } from '~c/services';
import { errorHandler } from '~c/services/error-handler';

/**
 * Common point for handling errors in redux
 */
const rtkQueryErrorLogger: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action)) {
      // const { endpointName } = action.meta.arg;
      const error = action.payload;
      const { message, statusCode } = errorHandler(error);
      // Don't show 401 - unauthorized error
      if (message && statusCode !== 401) {
        // UIkit.modal.dialog(
        //   `<p class="uk-modal-body">"INTERNAL SERVER ERROR" Please try again!<br/>${message}</p>`
        // );
      }
    }
    return next(action);
  };

const reduxStore = (preloadedState?: any) => {
  const reducer = {
    ...reducers,
    ...apiReducers,
  };

  /**
   * It's possible to wipe the redux via this reducer
   */
  // const reducerWithReset: Reducer =
  //   (reducer) => (state: RootState, action: AnyAction) => {
  //     if (action.type === 'resetRedux') {
  //       state = {} as RootState;
  //     }
  //     return combineReducers(reducer)(state, action);
  //   };

  const store = configureStore({
    reducer,
    preloadedState,
    middleware: (getDefaultMiddleware) => {
      let mw = getDefaultMiddleware({
        // Relax immutable check threshold to avoid dev slowdown (default 32ms)
        immutableCheck: { warnAfter: 128 },
      });
      apiSlices.forEach((api) => {
        // @ts-expect-error
        mw = mw.concat(api.middleware);
      });
      return mw.concat(rtkQueryErrorLogger);
    },
  });

  setupListeners(store.dispatch);
  return store;
};

export default reduxStore;

type ReduxStore = ReturnType<typeof reduxStore>;
export type RootState = ReturnType<ReduxStore['getState']>;
export type AppDispatch = ReduxStore['dispatch'];
export { actions };
